export interface InfoTypeExposure {
  id: string;
  high: number;
  medium: number;
  low: number;
}

export interface DetectionState {
  dashboard: InfoTypeExposure[];
  regulated: Record<
    number,
    { id: number; 0: number; 1: number; 2: number; 3: number }
  >;
  pii_items: InfoTypeExposure[];
  displayRisks: boolean;
}

export const SEED: DetectionState = {
  displayRisks: false,
  regulated: {},
  pii_items: [],
  dashboard: Array(6)
    .fill("")
    .map((t, i) => ({ id: i + "", high: 0, medium: 0, low: 0 })),
};
